import React, { useContext, useEffect, useRef, useState } from "react";
import constants from "../../constants";
import { getDataFromStorage } from "../../util";
import logo from "../../assets/images/logo.png";
import { useLocation } from "react-router-dom";
import AlertContext from "../../context/AlertContext";
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import Loading from "../Notification-Loading/Loading/Loading";
import useCommonFunctionHooks from "../../Hooks/useCommonFunctionHooks";
import useS3FileManagement from "../../Hooks/useS3FileManagement";
// import "./CompanyDropDown.css"; // 👈 Create this file for styling

const CompanyDropDown = () => {
    const { getPreSignedUrl } = useS3FileManagement();
    const Alert = useContext(AlertContext);
    const axios = useAxiosPrivate();
    const useCommonFunctionHks = useCommonFunctionHooks();
    const location = useLocation();
    const from = useRef(location?.state?.from?.pathname || "/");
    const [isDropdownLoading,setIsDropdownLoading]=useState(false);
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        setIsDropdownLoading(true);
        axios
            .get("/node/learner/accounts", useCommonFunctionHks.getHeaderDetailsForAxios())
            .then(async (res) => {
                if (res.data?.resultCode === constants.RESULT_STATUS.SUCCESS) {


                    const companies = res.data.data;
                    
                    // Step 1: Filter companies which need S3 URLs
                    const s3Companies = companies.filter(c => c.id !== 1 && c.logo);

                    // Step 2: Extract keys
                    const keys = s3Companies.map(c => c.logo);

                    // Step 3: Get all signed URLs in ONE API call
                    let signedUrls = [];
                    if (keys.length > 0) {
                        const resUrls = await getPreSignedUrl(keys, undefined, "", "GET");
                        signedUrls = resUrls?.url || [];
                    }

                    // Step 4: Map key → URL
                    const urlByKey = new Map();
                    keys.forEach((key, index) => {
                        if (signedUrls[index]) {
                            urlByKey.set(key, signedUrls[index]);
                        }
                    });

                    // Step 5: Build final company data
                    const companyData = companies.map(company => {
                        return {
                            name: company.name,
                            company_id: company.id,
                            favicon: company.favicon,
                            logo: company.id === 1 ? logo : urlByKey.get(company.logo) || null,
                            premium_features: company.premium_features,
                            type:company.type,
                        };
                    });

                    // Step 6: Set state
                    setCompanyList(companyData);

                    // Step 7: Set selected company
                    const storedId = getDataFromStorage("companyId");
                    const matchedCompany = companyData.find(c => c.company_id == storedId);
                    setSelectedCompany(matchedCompany || companyData[0]);
                }
            })
            .catch((error) => {
                useCommonFunctionHks.getCatchBlockDetails(error);
            })
            .finally(() => setIsDropdownLoading(false));
    }, []);

    const handleSelect = (company) => {
        setDropdownOpen(false);
        setSelectedCompany(company);
        setIsDropdownLoading(true);

        axios
            .get(`/node/admin/${getDataFromStorage("learnerid")}/account/${company.company_id}`, useCommonFunctionHks.getHeaderDetailsForAxios())
            .then((res) => {
                if (res.status === 200) {
                    localStorage.setItem("tokenKey", res.data.accessToken);
                    localStorage.setItem("refreshToken", res.data.refreshToken);
                   
                    localStorage.setItem("companyId", company.company_id);
                    localStorage.setItem("university_type", company.type);
                    console.log("Companies Resposne : ",company);
                    const encodedData = btoa(JSON.stringify(company));
                    localStorage.setItem("account_response", encodedData);

                    const isAdmin = getDataFromStorage("role") === constants.Roles.super_admin;
                    Alert.setIsAdmin(isAdmin);
                    setTimeout(() => {
                        const path = isAdmin ? "/batches" : "/main/landing";

                        from.current = path;

                        if (window.location.pathname === path) {
                            window.location.reload();
                        } else {
                            Alert.navigate(path, { replace: true });
                        }
                    }, 100);
                } else {
                    Alert.setShowNotify({
                        show: true,
                        title: "Error",
                        msg: res.data.message,
                    });
                }
            })
            .catch((error) => {
                useCommonFunctionHks.getCatchBlockDetails(error);
            })
            .finally(() => setIsDropdownLoading(false));
    };

    return (
        companyList.length > 1 && (
            <div className="custom-dropdown-container" tabIndex="-1" >
                {/* {Alert.isLoaded && <Loading />} */}

                <div className="custom-dropdown" tabIndex="-1" onClick={() => setDropdownOpen(!dropdownOpen)}>
                    {selectedCompany && (
                        <div className="selected-item" tabIndex="-1">
                            <div className="info-group">
                                <img src={selectedCompany.logo} alt={selectedCompany.name} />
                                <span className="company-name">{selectedCompany.name}</span>
                            </div>
                            <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: dropdownOpen ? "rotate(0deg)" : "rotate(180deg)", transition: "transform 0.3s ease" }}>
                                <path d="M9.60645 5L5.60645 1L1.60645 5" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    )}

                    {dropdownOpen && (
                        <ul className="dropdown-list" tabIndex="-1">
                            {companyList.map((company) => (
                                <li key={company.company_id} onClick={() => handleSelect(company)} tabIndex="-1">
                                    <img src={company.logo} alt={company.name} />
                                    <span className="company-name">{company.name}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        )
    );
};

export default CompanyDropDown;


